const UserActionTypes = {
  FETCH_CURRENT_USER_START: 'FETCH_CURRENT_USER_START',
  FETCH_CURRENT_USER_SUCCESS: 'FETCH_CURRENT_USER_SUCCESS',
  FETCH_CURRENT_USER_FAILURE: 'FETCH_CURRENT_USER_FAILURE',
  FETCH_USER_ALBUMS_START: 'FETCH_USER_ALBUMS_START',
  FETCH_USER_ALBUMS_SUCCESS: 'FETCH_USER_ALBUMS_SUCCESS',
  FETCH_USER_ALBUMS_FAILURE: 'FETCH_USER_ALBUMS_FAILURE',
  FETCH_USER_SONGS_START: 'FETCH_USER_SONGS_START',
  FETCH_USER_SONGS_SUCCESS: 'FETCH_USER_SONGS_SUCCESS',
  FETCH_USER_SONGS_FAILURE: 'FETCH_USER_SONGS_FAILURE',
  FETCH_USER_ARTISTS_START: 'FETCH_USER_ARTISTS_START',
  FETCH_USER_ARTISTS_SUCCESS: 'FETCH_USER_ARTISTS_SUCCESS',
  FETCH_USER_ARTISTS_FAILURE: 'FETCH_USER_ARTISTS_FAILURE'
};
export default UserActionTypes;
